import { render, staticRenderFns } from "./examCenters.vue?vue&type=template&id=e89006b2"
import script from "./examCenters.vue?vue&type=script&lang=js"
export * from "./examCenters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports